module.exports = __webpack_public_path__ + "static/media/iconMenuB.39ab62cd.svg";